import { createAppSlice } from "../../../store/createAppSlice";
import { createSelector } from "@reduxjs/toolkit";

export interface EvalLockedColumnsState {
  byEvalId: Record<string, string[]>;
}

const initialState: EvalLockedColumnsState = {
  byEvalId: {},
};

const evalLockedColumnsSlice = createAppSlice({
  name: "evalLockedColumns",
  initialState,
  reducers: (create) => ({
    toggleColumnLock: create.reducer<{ evalId: string; columnKey: string }>((state, action) => {
      const { evalId, columnKey } = action.payload;
      const current = state.byEvalId[evalId] ?? [];
      const isLocked = current.includes(columnKey);

      if (isLocked) {
        state.byEvalId[evalId] = current.filter((key) => key !== columnKey);
      } else {
        state.byEvalId[evalId] = [...current, columnKey];
      }
    }),

    clearLocks: create.reducer<{ evalId: string }>((state, action) => {
      delete state.byEvalId[action.payload.evalId];
    }),
  }),
  selectors: {
    getLockedColumnKeys: createSelector(
      [
        (state: EvalLockedColumnsState) => state.byEvalId,
        (_: EvalLockedColumnsState, evalId: string) => evalId,
      ],
      (byEvalId, evalId): string[] => byEvalId[evalId] ?? [],
    ),
  },
});

const { actions, selectors } = evalLockedColumnsSlice;

export { actions, selectors, evalLockedColumnsSlice };
